import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const subscriptFn = /* @__PURE__ */ createRecipe('subscript', {
  "color": "default",
  "size": "base",
  "textStyle": "italic",
  "fontWeight": "semibold"
}, [])

const subscriptVariantMap = {
  "size": [
    "small",
    "base",
    "large"
  ],
  "color": [
    "default",
    "secondary",
    "success",
    "warning",
    "error",
    "disabled"
  ],
  "textAlign": [
    "left",
    "center",
    "right",
    "justify"
  ],
  "textStyle": [
    "normal",
    "italic",
    "underline"
  ],
  "fontWeight": [
    "normal",
    "semibold",
    "bold"
  ],
  "style": [
    "normal",
    "emphasis"
  ],
  "shadow": [
    "none",
    "xlight",
    "light",
    "medium",
    "heavy"
  ]
}

const subscriptVariantKeys = Object.keys(subscriptVariantMap)

export const subscript = /* @__PURE__ */ Object.assign(memo(subscriptFn.recipeFn), {
  __recipe__: true,
  __name__: 'subscript',
  __getCompoundVariantCss__: subscriptFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: subscriptVariantKeys,
  variantMap: subscriptVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, subscriptVariantKeys)
  },
  getVariantProps: subscriptFn.getVariantProps,
})